if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      handleSubmit(evt) {
        evt.preventDefault();
        if (this.busy) return;
        this.busy = true;

        if (this.submitButton) this.submitButton.setAttribute('aria-disabled', 'true');

        const formData = new FormData(this.form);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[product-form] add to cart failed:', response.description || response.message);
              if (!this.cart) {
                window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            } else {
              this.openDrawerFallback(response);
            }
          })
          .catch((err) => {
            console.error('[product-form] add to cart error:', err);
            window.location = window.routes.cart_url;
          })
          .finally(() => {
            this.busy = false;
            if (this.submitButton) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      openDrawerFallback(response) {
        const html = response.sections && response.sections['cart-drawer'];
        const liveDrawer = document.querySelector('cart-drawer');
        if (!liveDrawer) return;

        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshDrawer = doc.querySelector('cart-drawer');
          if (freshDrawer) {
            liveDrawer.innerHTML = freshDrawer.innerHTML;
            const freshClasses = freshDrawer.className.split(' ').filter((c) => c && c !== 'active');
            liveDrawer.className = freshClasses.join(' ');
          }
        }

        if (typeof liveDrawer.open === 'function') {
          liveDrawer.open();
        } else {
          liveDrawer.classList.remove('is-empty');
          liveDrawer.classList.add('active');
        }
      }
    }
  );
}
